var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home" }, [
    _vm.showVideo
      ? _c(
          "video",
          {
            ref: "bgVideo",
            staticClass: "home-bg-video",
            attrs: {
              poster: _vm.poster,
              autoplay: "",
              loop: "",
              muted: "",
              playsinline: "",
              "webkit-playsinline": "",
              "x5-playsinline": "",
              preload: "auto",
              "aria-hidden": "true",
              tabindex: "-1",
            },
            domProps: { muted: true },
            on: {
              error: function ($event) {
                _vm.showVideo = false
              },
            },
          },
          [
            _c("source", { attrs: { src: _vm.webm, type: _vm.webmType } }),
            _vm._v(" "),
            _c("source", {
              attrs: { src: _vm.mp4, type: "video/mp4" },
              on: {
                error: function ($event) {
                  _vm.showVideo = false
                },
              },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "home-inner" },
      [
        _c("h1", { staticClass: "home-logo" }, [
          _vm._v("\n      搜狗视频\n    "),
        ]),
        _vm._v(" "),
        _c("SearchBar"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }